import React, { useState, useRef } from 'react';
import axios from 'axios';

const SearchUser = () => {
  const [query, setQuery] = useState('');
  const [users, setUsers] = useState([]);
  const timeoutId = useRef(null);

  const searchUsers = async (query) => {
    try {
      const response = await axios.get('/users/search', {
          params: {
              query
          }
      });

      if (Array.isArray(response.data)) {
        setUsers(response.data);
      } else {
        // console.error('Expected an array but got', response.data);
        setUsers([]); // Ensure users is always an array
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleQueryChange = (e) => {
    const newQuery = e.target.value;
    setQuery(newQuery);

    // Clear the previous timeout if there is one
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }

    // Set a new timeout
    timeoutId.current = setTimeout(() => searchUsers(newQuery), 700);
  };

  return (
    <div>
      <input type="text" className='spot-title spot-explore' id="search-field-id" value={query} onChange={handleQueryChange} placeholder="名前、ニックネーム、地域、車名" />
      <div className='user-search-result'>
        {users.map(user => {
          return (
            <div key={user.id}>
              <a className='user-list' href={`/users/${user.id}`}>
                <img src={user.icon_img?.url || 'https://drivemate2023.s3.ap-northeast-1.amazonaws.com/uploads/user/user_default.png'} alt={`検索結果アイコン${user.id}`} />
                <p>{user.nickname}</p>
              </a>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SearchUser;
